document.addEventListener("DOMContentLoaded", function () {
  let targetNode = document.querySelector("[data-cart-bottom]");

  let config = { childList: true, subtree: true };

  let callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        // Look for the Gift Note checkbox when it's injected
        let giftNoteCheckbox = document.querySelector(
          'input#checkbox_giftwrap[type="checkbox"]'
        );

        if (giftNoteCheckbox) {

          const addGiftNoteButton = document.getElementById("add-gift-note");
          const removeGiftNoteButton = document.getElementById("remove-gift-note");
      
          addGiftNoteButton.addEventListener("click", function (event) {
            event.preventDefault();

            if (giftNoteCheckbox.checked) {
              return;
            }

            event.target.classList.add("btn");
            event.target.classList.remove("btn--outline");
            event.target.nextElementSibling.classList.add("btn--outline");
            event.target.nextElementSibling.classList.remove("btn");
            giftNoteCheckbox.click();
          });
      
          removeGiftNoteButton.addEventListener("click", function (event) {
            event.preventDefault();

            if (!giftNoteCheckbox.checked) {
              return;
            }

            event.target.classList.add("btn");
            event.target.classList.remove("btn--outline");
            event.target.previousElementSibling.classList.add("btn--outline");
            event.target.previousElementSibling.classList.remove("btn");
            giftNoteCheckbox.click();
          });
          // Attach event listener if checkbox is found
          giftNoteCheckbox.addEventListener("change", function (event) {
            if (event.target.checked) {
              addGiftNoteToCart();
              // toggleGiftNoteTypeOptions(true);
              toggleGiftNoteTextArea(true);
            } else {
              removeGiftNoteFromCart();
              // resetButtons();
              // toggleGiftNoteTypeOptions(false);
              toggleGiftNoteTextArea(false);
              // toggleGiftNoteButton(false);
            }
          });

          document.addEventListener("theme:cart:change", function () {
            updateCheckboxState();
          });
          // Once the checkbox is detected and listener added, we can disconnect the observer
          observer.disconnect();
        }
      }
    }
  };

  let observer = new MutationObserver(callback);

  if (targetNode) {
    observer.observe(targetNode, config);
  }

  addNoteButtonEventListeners();

  function addNoteButtonEventListeners() {
    const physicalNoteButton = document.getElementById("add-physical-note");
    const physicalAndDigitalNoteButton = document.getElementById(
      "add-physical-and-digital-note"
    );

    if (!physicalNoteButton || !physicalAndDigitalNoteButton) return;

    // physicalNoteButton.addEventListener("click", function (event) {
    //   event.preventDefault();
    //   event.target.classList.add("btn");
    //   event.target.classList.remove("btn--outline");
    //   event.target.nextElementSibling.classList.add("btn--outline");
    //   event.target.nextElementSibling.classList.remove("btn");
    //   toggleGiftNoteButton(false);
    //   toggleGiftNoteTextArea(true);
    // });

    // physicalAndDigitalNoteButton.addEventListener("click", function (event) {
    //   event.preventDefault();
    //   event.target.classList.add("btn");
    //   event.target.classList.remove("btn--outline");
    //   event.target.previousElementSibling.classList.add("btn--outline");
    //   event.target.previousElementSibling.classList.remove("btn");
    //   toggleGiftNoteButton(true);
    //   toggleGiftNoteTextArea(false);
    // });
  }

  // function resetButtons() {
  //   const physicalNoteButton = document.getElementById("add-physical-note");
  //   const physicalAndDigitalNoteButton = document.getElementById(
  //     "add-physical-and-digital-note"
  //   );

  //   if (!physicalNoteButton || !physicalAndDigitalNoteButton) return;

  //   physicalNoteButton.classList.remove("btn");
  //   physicalNoteButton.classList.add("btn--outline");
  //   physicalAndDigitalNoteButton.classList.remove("btn");
  //   physicalAndDigitalNoteButton.classList.add("btn--outline");
  // }

  // Function to add the proxy product
  function addGiftNoteToCart() {
    const addGiftNoteButton = document.getElementById("add-gift-note");
    const removeGiftNoteButton = document.getElementById("remove-gift-note");

    addGiftNoteButton.disabled = true;
    removeGiftNoteButton.disabled = true;

    let proxyProductId = "45615842033885";
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: proxyProductId,
        quantity: 1
      })
    })
      .then((response) => response.json())
      .then((data) => {
        refreshCart();
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        addGiftNoteButton.disabled = false;
        removeGiftNoteButton.disabled = false;
      });

  }

  // Function to remove the proxy product
  function removeGiftNoteFromCart() {
    let proxyProductId = "45615842033885";

    // Old implementation of cart removal, deprecated because it's
    // better to just simualte a click on the proxy product's remove button
    /* fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: proxyProductId,
        quantity: 0
      })
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Removed Gift Note from cart", data);
        refreshCart();
      })
      .catch((error) => console.error("Error:", error)); */

    // New implementation
    let removeButton = document.querySelector(
      `[data-remove-key^="${proxyProductId}:"]`
    );
    if (!removeButton) return;
    removeButton.click();
  }

  // Function to refresh cart
  function refreshCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        let qtyInput = document.querySelector("[data-quantity-input]");
        if (!qtyInput) return;
        qtyInput.dispatchEvent(new Event("change"));
      })
      .catch((error) => console.error("Error refreshing cart:", error));
  }

  // Function to update app checkbox state
  function updateCheckboxState() {
    let proxyProductId = "45615842033885";
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        let giftNoteCheckbox = document.querySelector(
          'input#checkbox_giftwrap[type="checkbox"]'
        );

        if (giftNoteCheckbox) {
          const addGiftNoteButton = document.getElementById("add-gift-note");
          const removeGiftNoteButton = document.getElementById("remove-gift-note");

          // Check if the cart contains the item
          let itemInCart = data.items.some(
            (item) => item.id === parseInt(proxyProductId, 10)
          );
          giftNoteCheckbox.checked = itemInCart;
          // toggleGiftNoteTypeOptions(itemInCart);
          toggleGiftNoteTextArea(itemInCart);

          if(itemInCart) {
            addGiftNoteButton.classList.remove('btn--outline');
            addGiftNoteButton.classList.add('btn');
            removeGiftNoteButton.classList.add('btn--outline');
            removeGiftNoteButton.classList.remove('btn');
          } else {
            removeGiftNoteButton.classList.remove('btn--outline');
            removeGiftNoteButton.classList.add('btn');
            addGiftNoteButton.classList.add('btn--outline');
            addGiftNoteButton.classList.remove('btn');
          }
          
        }
      })
      .catch((error) => console.error("Error updating checkbox state:", error));
  }

  // function toggleGiftNoteButton(isVisible) {
  //   let giftNoteButtonWrapper = document.getElementById(
  //     "gift-note-button-wrapper"
  //   );
  //   if (giftNoteButtonWrapper) {
  //     giftNoteButtonWrapper.style.display = isVisible ? "block" : "none";
  //   }
  // }

  function toggleGiftNoteTextArea(isVisible) {
    let giftNoteTextareaWrapper = document.getElementById(
      "gift-note-text-area-wrapper"
    );
    if (giftNoteTextareaWrapper) {
      giftNoteTextareaWrapper.style.display = isVisible ? "block" : "none";
    }
  }

  // function toggleGiftNoteTypeOptions(isVisible) {
  //   let giftNoteOptionsElement = document.getElementById("note-type-options");
  //   if (giftNoteOptionsElement) {
  //     giftNoteOptionsElement.style.display = isVisible ? "block" : "none";
  //   }
  // }

  (function () {
    const textArea = document.getElementById("gift-note-text-area");
    const charCountLabel = document.getElementById("char-count");

    if (textArea) {
      const maxLength = textArea.maxLength;
      textArea.value = "";
      charCountLabel.innerHTML = 0;
  
      textArea.addEventListener("input", function () {
        const remainingChars = textArea.value.length;
        if (textArea.value.length === maxLength - 1) return;
        charCountLabel.innerHTML = remainingChars;
      });
    }
  })();
});
